import { connect } from 'react-redux';
import AnalyticsProvider from './AnalyticsProvider';

const mapStateToProps = (state: any) => {
  return {
    appUser: state.authentication.person,
    client: state.client,
  };
};

export default connect(mapStateToProps)(AnalyticsProvider);
